/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Supports_VisionInputs */



/**
* | output |
* | --- |
* | "Supports Vision" |
*
* @param {Private_Models_Form_Supports_VisionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_supports_vision = /** @type {((inputs?: Private_Models_Form_Supports_VisionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Supports_VisionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterstützt Vision")
	return /** @type {LocalizedString} */ ("Supports Vision")
});